// extracted by mini-css-extract-plugin
export default {"commonFont":"e-form-mortgage-deal_commonFont__kqw1u","box":"e-form-mortgage-deal_box__33Q9i","formBox":"e-form-mortgage-deal_formBox__pToXN"};